<template>
	<section>
		<div class="pc100W agileits" style="margin-top: 80px;min-height: 300px;">
			<div class="pcMaxW">
				<van-swipe class="swipeDescs" :autoplay="5000" lazy-render>
				  <van-swipe-item>
					  <div style="position: relative;">
						  <div class="bigTitle">關於我們</div>
						  <div class="desc">About Us</div>
				      </div>
				    </van-swipe-item>
					
				</van-swipe>
			</div>
		</div>
		<div class="imgContainer" style="background: #f4f4f4;">
			<section class="">
				<div class="pcMaxW p-5 container">
					<div class="dFlex alCenter jcBetween title mb-4">
						<h5 class="m-0 fw-normal">關於我們</h5>
					</div>
					<div class="texts">
						<!-- <p class="mb-4">
						{{ $t('footer.company') }}，總部位於國際金融中心——香港，是一家集研發、製造、發行與全球貿易於一體的多元化國際企業。
						</p><p class="mb-4">公司自創立以來，始終秉持「品質為本，創新驅動，誠信共贏」的經營理念，專注於數位娛樂產業，涵蓋手機遊戲、網路遊戲、跨平台互動娛樂產品的開發與全球推廣。我們擁有專業的技術研發團隊及具國際視野的市場營運團隊，致力於為全球用戶提供高品質、多元化的數位娛樂體驗。
						</p><p class="mb-4">同時，{{ $t('footer.company') }} 積極拓展國際合作，業務遍佈亞洲、歐洲、北美、南美及中東等多個地區，與眾多全球知名企業建立了長期穩定的合作夥伴關係。
						</p><p class="mb-4">展望未來，我們將持續加大研發投入，擁抱最新科技，優化產品品質，拓展更廣闊的國際市場，攜手全球合作夥伴共同開創數位娛樂新格局。
						</p><p class="mb-4">{{ $t('footer.company') }}
						</p><p class="mb-4">—— 讓創意點亮未來，讓娛樂連接世界。
						</p> -->
						<p class="mb-4">
						zijing 是一位專注於手機與獨立遊戲創作的個人開發者，致力於以小團隊思維打造高品質的娛樂體驗。開發理念以「創意先行、玩法為本」為核心，強調遊戲的可玩性與視覺表現的平衡，並在細節中追求沉浸感與玩家互動的真實回饋。
						</p><p class="mb-4">zijing 的作品多以幻想與冒險題材為主，融合東方美學與現代遊戲機制，力求為玩家帶來獨特的故事氛圍與深度玩法。目前正持續開發多款新作，涵蓋角色扮演、策略與模擬等多種類型，並積極與玩家社群保持互動，吸收反饋以優化遊戲體驗。
						</p><p class="mb-4">作為個人開發者，zijing 相信遊戲不僅是一種娛樂形式，更是傳遞情感與創意的橋樑。未來將持續以熱情與技術探索更多可能，打造讓全球玩家都能共鳴的優質遊戲作品。
						</p>
					</div>
				</div>
			</section>
		</div>
	</section>
	
</template>

<script setup>
	import { ref,onMounted,getCurrentInstance } from 'vue'
	const banner = ref(require('@/assets/images/hongkong_001.jpg'))
</script>

<style lang="less" scoped>
	.imgContainer{
		overflow: hidden;position: relative;padding: 60px 0;
		img{
			width: 100%;vertical-align: middle;border-radius: 23px;
		}
		.texts{
			font-size: 14px;color: #000;line-height: 30px;
		}
	}
</style>